import { type HighlightsController } from '@databases/highlights';
import { createFocusBoxEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface FocusBoxEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createFocusBoxEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FOCUS_BOX_EFFECT,
    type: 'effect',
    // Always active — the focus box is the primary cell border
    // highlighting and is fundamental to the selections machine.
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createFocusBoxEffect(highlightsController);
    },
  };
}
